// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import get from 'lodash/get'
import { inject } from 'mobx-react'
import React from 'react'
import { Query } from 'react-apollo'
import { Redirect, withRouter } from 'react-router-dom'
import Container from '../../common/container/Container'
import Loader from '../../common/loader/Loader'
import Page from '../../common/page/Page'
import { alphaSort } from '../../common/utils'
import withUser from '../auth/withUser'
import Header from '../header/Header'
import { i18n } from '../index'
import css from './StationPage.css'
import { fetchStationList } from './stationQueries'
import type { Station, StationStore } from './stationTypes'
type StationRedirectProps = {
  station: Station
  stationStore: any
}

@inject('stationStore')
class StationRedirect extends React.Component<StationRedirectProps> {
  render() {
    const { station } = this.props
    if (!station) {
      return <Redirect to='/ei-toimipaikkaa' />
    }
    this.props.stationStore.setActiveStationId(station.id)
    return <Redirect to='/' />
  }
}

type StationViewProps = {
  data: Station
  onClick: (...args: Array<any>) => any
}

const StationView = ({ data, onClick }: StationViewProps) => (
  <Button className={css.button} color='primary' variant='contained' onClick={onClick}>
    {data.name}
  </Button>
)

type StationPageProps = {
  history: any
  stationStore: StationStore
}

@withUser
@inject('stationStore')
class StationPage extends React.PureComponent<StationPageProps> {
  onChangeStation = (station: Station) => {
    this.props.stationStore.setActiveStationId(station.id)
    this.props.history.push('/')
  }

  renderList = (stations: Station[]) => (
    <div className={css.list}>
      {stations.length === 0 ? (
        <div className={css.empty}>{i18n.t('stationSelection.empty', 'Ei toimipaikkoja')}</div>
      ) : (
        alphaSort('name', stations).map((station, i) => (
          <StationView data={station} onClick={() => this.onChangeStation(station)} key={i} />
        ))
      )}
    </div>
  )

  render() {
    const {
      user: { stations, userType },
    } = this.props
    return (
      <Page>
        <Header showNav={false} />
        <Container>
          <div className={css.content}>
            <Typography component='h1' className={css.title}>
              {i18n.t('stationSelection.header')}
            </Typography>

            {userType === 'User' || userType === 'Manager' ? (
              stations.length > 1 ? (
                this.renderList(stations)
              ) : (
                <StationRedirect station={stations[0]} />
              )
            ) : (
              <Query query={fetchStationList}>
                {({ loading, error, data }) => (
                  <Loader loading={loading} error={error}>
                    {this.renderList(get(data, 'stations.edges', []).map(({ node }) => node))}
                  </Loader>
                )}
              </Query>
            )}
          </div>
        </Container>
      </Page>
    )
  }
}

export default withRouter(StationPage)
